import CMS from "netlify-cms";
import BlogPostPreview from "./preview-templates/BlogPostPreview";
import { LowerCaseInput, LowerCaseInputPreview } from "./LowerCaseInput";

CMS.registerPreviewTemplate("blog", BlogPostPreview);
CMS.registerWidget("lowerCaseInput", LowerCaseInput, LowerCaseInputPreview);
